import styled, { css } from 'styled-components';

import type { ModalProps } from '@tager/web-components';

import { media } from '@/utils/mixin';
import SuccessForm from '@/components/Forms/SuccessForm';

import CloseButton from '../shared/CloseButton';

function SuccessModal({ closeModal }: ModalProps) {
  return (
    <Component>
      <CloseButton onClick={closeModal} />
      <SuccessForm />
    </Component>
  );
}

const Component = styled.div`
  min-width: 674px;
  position: relative;
  padding: 25px 40px;
  border-radius: 10px;

  ${media.mobile(css`
    min-width: auto;
    padding: 20px;
  `)}

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${({ theme }) => theme.white_1};
`;

export default SuccessModal;
